<template>
  <footer class="the-footer">
    <div class="container">
      <div class="the-footer__top" v-if="$store.state.appConfig.appConfigReady">
        <div class="row justify-content-md-between">
          <div class="col-6 col-md-auto mb-4">
            <ul class="footer-items">
              <li>
                <div class="company-title">
                  <div class="logo-w">
                    <img class="logo" :src="$store.getters['appConfig/getAppLogo']" alt="Logo">
                  </div>

                  <span class="align-self-center" v-if="$store.getters['isPicaThirdLevelDomain']">getpica.com</span>
                  <span v-else>&nbsp;</span>
                </div>
              </li>
              <li>
                <div class="company-hq">
                  <template v-if="$store.getters['isPicaThirdLevelDomain']">
                    <b>Pica Group S.p.A.</b><br>
                    Via Dell'Aprica, 12,<br>
                    20158 Milano
                  </template>
                  <template v-else>
                    <div v-html="$store.getters['appConfig/getFooterCompanyInfo']"></div>
                  </template>

                </div>
              </li>
            </ul>
          </div>

          <template v-if="$store.state.appConfig.footerCategories">
            <div class="col-2 col-md-auto mb-4"
                 v-for="(category, index) in $store.getters['appConfig/getFooterCategories']" :key="index">
              <ul class="footer-items">
                <li><span>{{ category.label }}</span></li>
                <li v-for="(item, index) in category.items" :key="index">
                  <a :href="item.link" :target="item.link_target">{{ item.label }}</a></li>
              </ul>
            </div>
          </template>

          <template v-else>
            <div class="col-6 col-md-auto mb-4">
              <ul class="footer-items">
                <li><span>{{ $t('menu.company') }}</span></li>
                <li><a href="https://business.getpica.com" target="_blank">{{ $t('menu.about_pica') }}</a></li>
                <li v-for="(policy, index) in policies" :key="index">
                  <a :href="policy.url" :target="policy.target" rel="noindex">{{ policy.title }}</a>
                </li>
              </ul>
            </div>
          </template>

          <div class="col-6 col-md-auto mb-4">
            <ul class="footer-items">
              <li><span>{{ $t('menu.account') }}</span></li>
              <template v-if="isAuthenticated">
                <template v-for="(item, index) in menuAccount">
                  <li :key="index" v-if="item.visible === undefined || item.visible">
                    <router-link v-if="item.to" :to="item.to">{{ item.label }}</router-link>
                    <a href="#" v-else-if="item.action" @click.prevent="item.action">{{ item.label }}</a>
                    <a :href="item.href" target="_blank" v-else>{{ item.label }}</a>
                  </li>
                </template>
                <ImpersonateLink/>
              </template>
              <template v-else>
                <li>
                  <router-link :to="{ name: 'signup'}">{{ $t('menu.create_account') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'reset-password'}">{{ $t('menu.reset_password') }}</router-link>
                </li>
              </template>
            </ul>
          </div>
          <div class="col-6 col-md-auto mb-4">
            <ul class="footer-items">
              <li><span>{{ $t('menu.menu') }}</span></li>
              <li v-if="isAuthenticated">
                <a href="#" @click.prevent="$bvModal.show('bv-modal-checkin-maker')">
                  {{ $t('menu.do_checkin_footer') }}
                </a>
              </li>
              <li v-if="isAuthenticated">
                <router-link :to="{ name: 'checkins-list'}">
                  {{ $t('menu.checkins_list') }}
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'help', query: {eventId: picaServiceId}}"
                             v-if="$store.getters['isPicaThirdLevelDomain']">
                  {{ $t('menu.support') }}
                </router-link>
                <a :href="getContactUrl()" target="_blank" v-else>
                  {{ $t('menu.support') }}
                </a>
              </li>
            </ul>
          </div>
          <div class="col-6 col-md-auto mb-4"
               v-if="$store.state.appConfig.appConfigReady && !$store.state.appConfig.hideAppStoreLinks">
            <ul class="footer-items">
              <li>
                <span>Get Pica</span>
              </li>
              <li>
                <a :href="APP_STORES_URL.appStore" target="_blank">
                  <img :src="getUrlBadgeAppStore" alt="App Store">
                </a>
              </li>
              <li>
                <a :href="APP_STORES_URL.playStore" target="_blank">
                  <img :src="getUrlBadgeGooglePlay" alt="Google Play">
                </a>
              </li>
              <li>
                <a :href="APP_STORES_URL.huaweiStore" target="_blank">
                  <img :src="getUrlBadgeHuawei" width="119px" alt="Google Play">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container the-footer__bottom">
      <div class="row justify-content-md-between">

        <div class="col-xl-auto mb-3 order-xl-last">
          <div class="row justify-content-center justify-content-xl-between align-items-center">
            <div class="col-sm-6 col-md-auto mb-4">
              <LocaleChanger/>
            </div>
            <div class="col-sm-6 col-md-auto mb-4"
                 v-if="$store.state.appConfig.appConfigReady && !$store.state.appConfig.hideAppStoreLinks">
              <ul class="list-inline social-pica">
                <li class="list-inline-item"><a href="https://www.facebook.com/GetPica/" target="_blank">
                  <img src="@/assets/icon-fb.svg"></a>
                </li>
                <li class="list-inline-item">
                  <a href="https://www.instagram.com/getpica/" target="_blank">
                    <img src="@/assets/icon-ig.svg">
                  </a>
                </li>
                <!-- twitter -->
                <li class="list-inline-item">
                  <a href="https://twitter.com/getpica" target="_blank">
                    <img src="@/assets/icon-tw.svg">
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="http://linkedin.com/company/getpica/" target="_blank">
                    <img src="@/assets/icon-lk.svg">
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="https://www.youtube.com/@getpica3170" target="_blank">
                    <img src="@/assets/icon-yt.svg" style="width: 28px">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-xl-auto mb-3 order-xl-first">
          <div class="the-footer__bottom__item">
            &copy; {{ new Date().getFullYear() }} {{ $t('menu.footer_credits') }} | {{ $t('menu.footer_partita_iva') }}
            02529950392 | {{ $t('menu.footer_capitale_sociale') }} | {{ $t('menu.footer_patented') }}
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>


<script>
import {mapGetters} from 'vuex'
import LocaleChanger from "@/components/LocaleChanger"
import {APP_STORES_URL, getContactUrl} from "@/utils";
import ImpersonateLink from "@/domain/impersonate/ImpersonateLink.vue";

export default {
  name: "TheFooter",
  components: {ImpersonateLink, LocaleChanger},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['thirdLevelDomain']),
    ...mapGetters('auth', [
      'isAuthenticated'
    ]),
    ...mapGetters('event', [
      'picaServiceId'
    ]),
    APP_STORES_URL() {
      return APP_STORES_URL
    },
    getUrlBadgeAppStore() {
      return require('@/assets/store-badges/AppStoreWhite.svg')
    },

    getUrlBadgeGooglePlay() {
      return require('@/assets/store-badges/GooglePlayWhite.svg')
    },

    getUrlBadgeHuawei() {
      return require('@/assets/store-badges/HuaweiWhite.png')
    },
    menuAccount() {
      return [
        {label: this.$t('menu.my_profile'), to: {name: 'profile-resume'}},
        {label: this.$t('menu.privacy_settings'), to: {name: 'profile-privacy'}},
        {
          label: 'Euroleague ventures privacy policy',
          href: '/media/files/euroleague/EV_PRIVACY_POLICY.pdf',
          visible: this.thirdLevelDomain === 'euroleague'
        },
        {label: this.$t('menu.password_change'), to: {name: 'profile-change-password'}},
        {label: this.$t('menu.cookie_settings'), action: this.openCookieSettings},
      ]
    },
    policies() {
      let currentLanguage = this.$i18n.locale
      const unavailableLanguages = ['pl', 'pt']
      if (unavailableLanguages.includes(currentLanguage)) currentLanguage = 'en'
      return [
        {
          url: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/privacy-policy-pica/`,
          title: this.$t('menu.privacy_policy'),
          target: '_blank'
        },
        {
          url: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/cookie-policy/`,
          title: this.$t('menu.cookie_policy'),
          target: '_blank'
        },
        {
          url: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/termini-condizioni-vendita/`,
          title: this.$t('menu.terms_conditions'),
          target: '_blank'
        },
        {
          url: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/info-legali/`,
          title: this.$t('menu.info_legali'),
          target: '_blank'
        },
      ]
    }
  },

  methods: {
    getContactUrl,
    openCookieSettings() {
      window.cookiehub.openSettings()
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => this.$router.push('/'))
    }
  },
}
</script>
